import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa'
import { Loader } from 'semantic-ui-react';
import { X } from 'phosphor-react';

import { useAuth } from '../../hooks/auth';
import { useSkills } from '../../hooks/skills';

import Header from '../../components/Header';
import SideMenu from '../../components/SideMenu';
import AddSkill from '../../components/AddSkill';
import AccordionProduct from '../../components/AccordionProduct';
import SkillNiveis from '../../components/SkillNiveis';

import { styleSheet } from '../../assets/styles/global';
import skillIcon from '../../assets/icons/skillIcon.svg'


import {
  Container,
  MainBody,
  Content,
  TitleContainer,
  TitleIcon,
  TitleText,
  Divider,
  ProductBody,
  Modulo,
  ModuloTop,
  ModuloBody,
  ModuloTitle,
  SkillsContainer,
  Skill,
  SkillTitleContainer,
  SkillTitle,
  AddProdutoContainer,
  AddProdutoHeader,
  Load,
  ButtonDelete,
  ModuloHeader,
  ButtonDeleteModulo
} from './styles';


const Skills: React.FC = () => {
  const [menuVisible, setMenuVisible] = React.useState(false)
  const { userIsLogged } = useAuth()
  const {
    products,
    modules,
    skills,
    moduloColor,
    fetchProducts,
    isLoading,
    isLoadingModules,
    isLoadingSkills,
    handleDeleteSkill,
    handleDeleteModulo,
    handleCleanState,
    codPai,
  } = useSkills()
  const history = useHistory()

  const handleLogout = async () => {
    await localStorage.removeItem('ethosxAnalista:token')
    await sessionStorage.removeItem('analystName')
    await sessionStorage.removeItem('token')

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    history.push('/login')

    window.location.reload();

  }

  useEffect(() => {
    if (!userIsLogged()) {
      history.push('/login')
    }
    handleCleanState('skill')
    handleCleanState('module')
    handleCleanState('product')
    fetchProducts()
    // eslint-disable-next-line
  }, [])

  return (
    <Container>
      <SideMenu currentMenu="skills" visible={menuVisible} onClose={() => setMenuVisible(false)} />

      {
        isLoading ? <Load><Loader active>Carregando</Loader></Load>
          :
          <MainBody>
            <Header screen="Skills" logout={handleLogout} onOpenMenu={() => setMenuVisible(true)} />
            <Content>
              <TitleContainer>
                <TitleIcon src={skillIcon} />
                <TitleText>Minhas Skills</TitleText>
              </TitleContainer>

              <Divider />


              {
                products?.map(product => (
                  <AccordionProduct
                    key={product.code}
                    codigo={product.code}
                    title={product.name}
                  >
                    {
                      isLoadingModules && product.code.trim() === codPai.trim()
                        ? <Load><Loader active>Carregando</Loader></Load>
                        : <ProductBody>
                          {
                            modules?.map(modulo => product.code.trim() === modulo.productCode.trim() && (
                              <Modulo key={modulo.name} isAddModule={false}>
                                <ModuloTop color={modulo.color} />
                                <ModuloBody>
                                  <ModuloHeader>
                                    <ModuloTitle>{modulo.name} </ModuloTitle>
                                    <ButtonDeleteModulo onClick={() => handleDeleteModulo(modulo.code)}>
                                      <X color={styleSheet.cancel} size={15} />
                                    </ButtonDeleteModulo>
                                  </ModuloHeader>
                                  {
                                    isLoadingSkills && modulo.code.trim() === codPai.trim()
                                      ? <Load><Loader active>Carregando</Loader></Load>
                                      : <SkillsContainer>
                                        {
                                          skills?.map(skill => modulo.code.trim() === skill.moduloCode.trim() && (
                                            <Skill key={skill.name}>
                                              <ButtonDelete onClick={() => handleDeleteSkill(skill.code)}><X color={styleSheet.cancel} size={15} /></ButtonDelete>
                                              <SkillTitleContainer>
                                                <SkillTitle>{skill.name}</SkillTitle>
                                              </SkillTitleContainer>
                                              <SkillNiveis code={skill.code} color={skill.color} nvl={skill.level} />
                                            </Skill>
                                          ))
                                        }

                                        <AddSkill color={modulo.color} type="skill" code={modulo.code} />
                                      </SkillsContainer>
                                  }

                                </ModuloBody>
                              </Modulo>
                            ))
                          }


                          <Modulo isAddModule={true}>
                            <ModuloTop color={moduloColor} />
                            <ModuloBody>
                              <AddSkill color={moduloColor} type="module" code={product.code} />
                            </ModuloBody>
                          </Modulo>

                        </ProductBody>

                    }

                  </AccordionProduct>
                ))
              }

              <AddProdutoContainer>
                <AddProdutoHeader>
                  <AddSkill color={styleSheet.titleLight} type="product" />
                </AddProdutoHeader>
              </AddProdutoContainer>

            </Content>
          </MainBody>
      }
    </Container>
  )
}

export default Skills;
